module.exports = {"610902001":"老城街道","610902002":"新城街道","610902003":"江北街道","610902004":"建民街道","610902100":"关庙镇","610902101":"张滩镇","610902102":"瀛湖镇","610902104":"五里镇","610902107":"恒口镇","610902109":"吉河镇","610902110":"流水镇","610902111":"大竹园镇","610902112":"洪山镇","610902114":"茨沟镇","610902115":"大河镇","610902116":"沈坝镇","610902117":"双龙镇","610902118":"叶坪镇","610902119":"中原镇","610902120":"县河镇","610902121":"紫荆镇","610902122":"早阳镇","610902123":"关家镇","610902124":"石梯镇","610902125":"坝河镇","610902128":"牛蹄镇","610902130":"晏坝镇","610902132":"谭坝镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610902.json
// module id = 3011
// module chunks = 0